import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { Login } from 'src/app/shared/object/login.interface';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TipoMensaje } from '../../../Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from '../../../Wheel.Styles.HighVolume/Notificacion';
import { empresa } from '../../shared/object/empresa.model';
import { sucursal } from '../../shared/object/sucursal.model';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import { SecurityService } from '../../shared/services/security.service';
import { ValidadoresService } from '../../shared/validadores/validadores';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  exportAs: "child",
  providers: [SecurityService, ValidadoresService]
})
export class LoginComponent implements OnInit {

  formulario: FormGroup;
  private client: GraphQLClient = null;
  public loading: boolean;
  loadingLogin: boolean;
  empresaList:empresa[];
  sucursalList:sucursal[];
  optionsEmpresa: Array<any> = [];
  optionsSucursal: Array<any> = [];
  usuarioLogueado = false;
  routeRedirect='';
  latitud : string = '';
  longitud : string = '';

  constructor(private authService:AuthService, 
    public router: Router, 
    public toastService: ToastService,
    private _SecurityService: SecurityService, 
    private fb: FormBuilder, 
    client: GraphQLClient, 
    public validadores: ValidadoresService,
    ){
    this.loadingLogin = false;
    this.loading = true;
    this.client = client;
    this.buildForm();
  }

  buildForm() {
    this.formulario = this.fb.group({
      rut_usuario: ['', [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.validadores.ValidaFormatoRut]],
      password: ['', [Validators.required]],
      rut_empresa:['', [Validators.required]],
      codigo_sucursal:['', [Validators.required]]
    });

    this.formulario.get('rut_empresa').valueChanges.subscribe(data=>{
      this.formulario.get('codigo_sucursal').setValue('');
      this.obtenerSucursalxEmpresa(this.formulario.controls["rut_empresa"].value);
    });
  }

  ngOnInit() {
    this.loading = false;
    setTimeout(() => this.obtenerEmpresa(), 500);
    this.usuarioLogueado= this.authService.isLoggedIn();
    this.authService.changeLoginStatus$.subscribe((loggedStatus: boolean)=>{
      this.usuarioLogueado = loggedStatus;
    })
    if (this.usuarioLogueado){
      this.router.navigate([this.routeRedirect]);
    }
  }

  onSubmit(): boolean {
    this.loading = true;
    const self = this;
    if (!this.formulario.valid) {
      this.loading = false;
      return false;
    }
    this.loadingLogin = true;
    const inputParams = {
      rut_usuario: Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.value.rut_usuario)),
      password: this.formulario.value.password,
      rut_empresa: this.formulario.value.rut_empresa,
      codigo_sucursal: this.formulario.value.codigo_sucursal,
      ip_address: this.authService.getIp(),
      user_agent: this.authService.getUserAgent()
    }
    this.client.query({
      query: gql`
      query ($rut_usuario:Decimal, $password:String, $rut_empresa:Decimal, $codigo_sucursal:Decimal, $ip_address:String, $user_agent:String)
      {
        login
        {
          inicioSeccion(rut_usuario:$rut_usuario, password: $password, rut_empresa:$rut_empresa, codigo_sucursal:$codigo_sucursal, ip_address:$ip_address, user_agent:$user_agent)
          {
            mensajes
            {
              codigo
              contexto
              texto
              tipo
            }
            respuesta 
            {
              rut_usuario
              access_token
              refresh_token
              access_token_expiration
            }
          }
        }
      }
        `,
      variables: inputParams,
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.loadingLogin = false;
      const notificacion: NotificacionGenerica<Login> = NotificacionGenerica.parse(respuesta.data.login.inicioSeccion);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // self._SecurityService.setToken(notificacion.respuesta.access_token);
        self._SecurityService.setRutUsuario(self.validadores._desenmascaraRutyQuitaDV(self.formulario.value.rut_usuario));
        self._SecurityService.setRutEmpresa(self.formulario.value.rut_empresa);
        self._SecurityService.setSucursalCodigo(self.formulario.value.codigo_sucursal);
        self._SecurityService.setLatitudEmpresa(self.latitud);
        self._SecurityService.setlongitudEmpresa(self.longitud);
        self.authService.login(notificacion.respuesta);
        self.routeRedirect = self.authService.urlUsuarioIntentaAcceder;
        self.authService.urlUsuarioIntentaAcceder='';
        self.router.navigate([self.routeRedirect]);
        self.router.navigate(['/dashboards/v1']);
        self.loading = true;
        return true;
      }
      else {
        self.toastService.error(
          notificacion.mensajes[0].texto,
          notificacion.mensajes[0].contexto,
          {
            timeOut: 12000,
            progressBar: true,
            opacity: 1,
          }
        )
        // alert(notificacion.mensajes[0].texto);
        self.loading = false;
        return false;
      }
    });
    this.loading = false;
    return false;
  }
  
  obtenerEmpresa() {
    let self = this; 
    this.client.query({
      query: gql`
        query {
          empresa{
            obtenerTodos{
              respuesta{
                registros{
                  rut
                  nombre
                  activo
                  es_holding
                  fecha_creacion
                  latitud
                  longitud
                }
              }
            }
          }
        }
        `
      ,
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.empresaList = respuesta.data.empresa.obtenerTodos.respuesta.registros;
      self.optionsEmpresa = [];
      let sel: any;
      self.empresaList.forEach(element => {
        if(element.activo == true){
          sel = { value: element.rut, label: element.nombre, lat: element.latitud,  lon:element.longitud };
          self.optionsEmpresa.push(sel);
        }
      });
    });
  }

  obtenerSucursalxEmpresa(rut_empresa:number) {
    rut_empresa;
    let self = this; 
    this.client.query({
      query: gql`
      query($rut_empresa:Decimal){
        sucursal{
          obtenerSucursalxEmpresa(rut_empresa:$rut_empresa){
            respuesta{
              registros{
                rut_empresa
                codigo
                nombre
                descripcion
                activo
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': rut_empresa,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.sucursalList = respuesta.data.sucursal.obtenerSucursalxEmpresa.respuesta.registros;
      self.optionsSucursal = [];
      var sel: any;
      self.sucursalList.forEach(element => {
        if(element.activo == true){
          sel = { value: element.codigo, label: element.nombre };
          self.optionsSucursal.push(sel);
        }
      });
      self.latitud = '';
      self.longitud ='';
      self.latitud = self.optionsEmpresa.find(p=> p.value === rut_empresa).lat
      self.longitud = self.optionsEmpresa.find(p=> p.value === rut_empresa).lon
    });
  }

  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }
}
